import { Pipe, PipeTransform, inject } from "@angular/core"
import { ContextService } from "../services"
import { Category } from "../models"

@Pipe({
    name: "categoryNames",
    pure: false,
    standalone: true,
})
export class CategoryNamesPipe implements PipeTransform {
    private _cs = inject(ContextService)

    constructor() {
        this._cs.InitCategories()
    }

    transform(ids: string | string[] | null | undefined): string {
        if (!ids) return ""
        const list = Array.isArray(ids) ? ids : [ids]
        const categories: Category[] = this._cs.getCategoriesSubject()?.value ?? []
        return list.map(id => categories.find(c => c.masterId === id)?.names?.["hr"] || id).join(", ")
    }
}
